// extracted by mini-css-extract-plugin
export default {"pricing__faq-title":"PricingFaq_pricing__faq-title__M1sZ+","pricing__faq":"PricingFaq_pricing__faq__5Q7wm","pricing__faq-btn":"PricingFaq_pricing__faq-btn__-fXLD"};